import { userSignInSuccess } from 'actions';
import {
    LanguageValues,
    UpdateDocumentDirection,
    UpdateUserAndStorage,
    UpdateUserLanguage,
    UpdateUserName,
} from './useLanguageChange.types';

import { supportedLanguages } from 'app/modules/CompanyManagement/Factories/AddEditFactory/components/utils/constant';
import { supportedLanguagesType } from 'app/modules/CompanyManagement/Factories/AddEditFactory/components/utils/constants.types';
import { ParsedAuthUserSelector } from '../useAuthuser/useAuthuser.types';

export const initialLangState = () => {
    const savedLang = localStorage.getItem('lang');
    if (savedLang) {
        try {
            const parsed = JSON.parse(savedLang) as supportedLanguagesType;
            if (parsed?.value) {
                return parsed.value;
            }
        } catch (e) {
            console.error('Failed to parse saved language', e);
        }
    }
    return supportedLanguages[0].value;
};

const updateUserName: UpdateUserName = ({
    dispatch,
    firstName,
    lastName,
    authUser,
}) => {
    authUser.firstName = firstName;
    authUser.lastName = lastName;
    localStorage.setItem('user_id', JSON.stringify(authUser));
    dispatch(userSignInSuccess(JSON.stringify(authUser)));
};

export const updateUserLanguage: UpdateUserLanguage = ({
    newLang,
    authUser,
    dispatch,
}) => {
    authUser.lang = newLang.value.toLowerCase() as Lowercase<LanguageValues>;
    authUser.systemLanguage =
        newLang.value.toLowerCase() as Lowercase<LanguageValues>;
    localStorage.setItem('user_id', JSON.stringify(authUser));
    dispatch(userSignInSuccess(JSON.stringify(authUser)));
};

export const updateUserAndStorage: UpdateUserAndStorage = ({
    newLang,
    dispatch,
    data,
}) => {
    localStorage.setItem('lang', JSON.stringify(newLang));
    const authUserStr = localStorage.getItem('user_id');
    if (!authUserStr) return;

    const firstName = data?.data?.firstName || '';
    const lastName = data?.data?.lastName || '';
    const authUser = JSON.parse(authUserStr) as ParsedAuthUserSelector;

    updateUserName({
        dispatch,
        firstName,
        lastName,
        authUser,
    });

    updateUserLanguage({
        newLang,
        authUser,
        dispatch,
    });
};

export const updateDocumentDirection: UpdateDocumentDirection = ({
    newLang,
}) => {
    document.documentElement.lang = newLang.locale;
    const bodyEl = document.getElementById('body');
    if (newLang.locale === 'ar') {
        document.dir = 'rtl';
        bodyEl?.classList.remove('englishFont');
        bodyEl?.classList.add('arabicFont');
        return;
    }
    document.dir = 'ltr';
    bodyEl?.classList.remove('arabicFont');
    bodyEl?.classList.add('englishFont');
};
